import R from 'ramda';
import utils from './utils';
const URL = `${BASE_API_URL}/v2/education/student/profile/`;
export default {
  fetchData : () => utils.get(URL),
  updateData : data => {
    if (data.image) {
      const formData = new FormData();
      R.forEachObjIndexed((value, key) => formData.append(key, value), data);
      return utils.upload(URL, formData);
    }
    return utils.patch(URL, data);
  }
}



// WEBPACK FOOTER //
// ./src/api/profile.js